import { gql } from 'react-apollo';

export const getEvangelist = gql`
  query getEvangelist($evangelistId: Int!) {
    evangelist: evangelist(id: $evangelistId) {
      id
      name
      email
      passwordCreated: password_created
      photo {
        small
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/queries/getEvangelist.js